import React, { useEffect } from "react";
import { ReactComponent as LeftIcon } from "../assets/image/LeftArrow.svg";
import DimondIcon from "../assets/image/dimondIcon.png";

export default function LeaderboardDialog({ open, setOpen, leaderboard }) {
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (open && !event.target.closest(".leaderboard-dialog")) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("click", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [open, setOpen]);

  const medal = (i) => {
    if (i === 0) return "🥇";
    if (i === 1) return "🥈";
    if (i === 2) return "🥉";
    return null;
  };

  return (
    <>
      {open && (
        <div className="leaderboard-dialog">
          <div className="dialog-box">
            <div className="dialog-head">
              <button onClick={() => setOpen(false)}>
                <LeftIcon />
              </button>
              <div>
                <h5>Top Earners</h5>
                <h6>Last 24 Hours — Top 100</h6>
              </div>
            </div>
            <div className="dialog-body">
              {leaderboard && leaderboard.length > 0 ? (
                <div className="table-scroll">
                <table>
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Player</th>
                      <th>Diamond</th>
                    </tr>
                  </thead>
                  <tbody>
                    {leaderboard.map((item, index) => (
                      <tr
                        key={item.userId || index}
                        className={index < 3 ? `rank-${index + 1}` : ""}
                      >
                        <td>
                          {medal(index) ? (
                            <span className="rank-badge">{medal(index)}</span>
                          ) : (
                            <span className="rank-num">{index + 1}</span>
                          )}
                        </td>
                        <td>
                          <div className="player-cell">
                            {item.image ? (
                              <img
                                src={item.image}
                                alt={item.name}
                                className="player-avatar"
                              />
                            ) : (
                              <div className="player-avatar-placeholder">
                                {item.name ? item.name.charAt(0).toUpperCase() : "?"}
                              </div>
                            )}
                            <span>{item.name || "Unknown"}</span>
                          </div>
                        </td>
                        <td>
                          <div className="diamond-cell">
                            <img src={DimondIcon} alt="diamond" />
                            <span>{item.totalDiamonds?.toLocaleString()}</span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
              ) : (
                <h5>No earners in the last 24 hours.</h5>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
